export const HOUR_GLASS_ICON = "fas fa-hourglass-half";
export const QUESTION_MARK_ICON = "fas fa-question"
export const INFO_MARK_ICON = "fas fa-info"
export const TICK_MARK_ICON = "fas fa-check"
export const TRIANGLE_WARNING_ICON="far fa-exclamation-triangle"